<template>
  <div>
    <list-layout
      :can-operate="canOperate"
      :column-default-selected="columnDefaultSelected"
      :columns-all="columnsAll"
      :default-selected="tableDefaultSelectData"
      :export-func="exportFunc"
      :get-table-data-func="getTableDataFunc"
      :group-tree-func="groupTreeFunc"
      :in-modal="inModal"
      :refresh="updateTableFlag"
      :route-params="$route.params"
      :table-operation-width="tableOperationWidth"
      :tools-list="toolsList"
      @tableSelectData="getSelectData"
      :apiPermission="groupApiPermission"
      :can-drag-column-width="true"
    >
      <template #leftTool>
        <create-button v-permission="{action: 'service.ssl_certificate.create', effect: 'disabled'}" @click="$refs.inputDrawer.show()">
        </create-button>
      </template>
      <!-- 表格自定义列 -->
      <template #name="{ slotProps }">
        <a-tooltip
          v-if="slotProps.record.status === 'abnormal'"
          title="已到期"
          style="margin-right: 4px"
        >
          <a-icon theme="filled" type="info-circle" style="color: #ff4d4f"></a-icon>
        </a-tooltip>
        <a-tooltip placement="topLeft" :title="slotProps.text">
          {{ slotProps.text }}
        </a-tooltip>
      </template>
      <template #statusTitle>
        <status-question-icon></status-question-icon>
      </template>
      <template #status="{ slotProps }">
        <source-status-tag :status="slotProps.text"></source-status-tag>
      </template>
      <template #operation="{ slotProps }">
        <sync-button @click="sync(slotProps.record.id)"></sync-button>
        <edit-button
        v-permission="{action: 'service.ssl_certificate.update', effect: 'disabled'}"
          @click="$refs.inputDrawer.show(slotProps.record.id)"
        ></edit-button>
        <delete-button v-permission="{action: 'service.ssl_certificate.delete', effect: 'disabled'}" @confirm="confirm(slotProps.record.id)"></delete-button>
      </template>
    </list-layout>

    <input-drawer ref="inputDrawer" @ok="confirm"></input-drawer>
  </div>
</template>

<script>
import {
  createSSLCertificateGroup,
  deleteSSLCertificate,
  deleteSSLCertificateGroup,
  exportSSLCertificate,
  getSSLCertificateGroup,
  getSSLCertificateGroupList,
  getSSLCertificateList,
  syncSSLCertificate,
  updateSSLCertificateGroup
} from '@/api/ssl-certificate'
import ListLayout from '@/components/ListLayout'
import DeleteButton from '@/components/button/DeleteButton'
import EditButton from '@/components/button/EditButton'
import CreateButton from '@/components/button/CreateButton'
import SyncButton from '@/components/button/SyncButton'
import StatusQuestionIcon from '@/components/icon/StatusQuestionIcon'
import SourceStatusTag from '@/components/tag/SourceStatusTag'
import { sourceStatuses } from '@/utils/const'
import { hasPermission } from '@/utils'

export default {
  name: 'SSLCertificateTable',
  components: {
    SourceStatusTag,
    DeleteButton,
    EditButton,
    InputDrawer: () => import('./modules/InputDrawer'),
    ListLayout,
    StatusQuestionIcon,
    SyncButton,
    CreateButton
  },
  props: {
    defaultSelected: {
      type: Array
    },
    toolsList: {
      type: Array,
      default: () => []
    },
    tableOperationWidth: {
      type: Number,
      default: 240
    },
    refresh: {
      type: Boolean
    },
    canOperate: {
      type: Boolean,
      default: true
    },
    inModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      getTableDataFunc: getSSLCertificateList,
      exportFunc: exportSSLCertificate,
      columnsAll: [
        {
          dataIndex: 'name',
          title: '名称',
          fixed: 'left',
          width: 200,
          ellipsis: true,
          scopedSlots: {
            customRender: 'name'
          }
        },
        {
          dataIndex: 'version',
          title: '版本',
          width: 120,
          ellipsis: true,
          scopedSlots: {
            customRender: 'version'
          }
        },
        {
          dataIndex: 'serial_number',
          title: 'SN',
          width: 200,
          ellipsis: true,
          scopedSlots: {
            customRender: 'serialNumber'
          }
        },
        {
          dataIndex: 'algorithm',
          title: '签名算法',
          width: 200,
          ellipsis: true,
          scopedSlots: {
            customRender: 'algorithm'
          }
        },
        {
          dataIndex: 'length',
          title: '长度',
          width: 100
        },
        {
          dataIndex: 'issuer',
          title: '签发机构',
          width: 200,
          ellipsis: true,
          scopedSlots: {
            customRender: 'issuer'
          }
        },
        {
          dataIndex: 'issued_at',
          title: '签发时间',
          width: 200
        },
        {
          dataIndex: 'expires_at',
          title: '到期时间',
          width: 200
        },
        {
          dataIndex: 'url',
          title: '检测 URL',
          width: 200,
          ellipsis: true,
          scopedSlots: {
            customRender: 'url'
          }
        },
        {
          dataIndex: 'status',
          width: 100,
          slots: {
            title: 'statusTitle',
            name: '状态'
          },
          scopedSlots: {
            customRender: 'status'
          },
          filters: sourceStatuses.map(value => {
            return {
              text: this.$t(`source_status.${value}`),
              value
            }
          }),
          filterMultiple: false
        },
        {
          dataIndex: 'created_at',
          title: '创建时间',
          width: 200
        },
        {
          dataIndex: 'updated_at',
          title: '更新时间',
          width: 200
        }
      ],
      columnDefaultSelected: [
        'name',
        'algorithm',
        'issuer',
        'expires_at',
        'status'
      ],
      updateTableFlag: this.refresh,
      tableSelectData: [],
      tableDefaultSelectData: [],
      groupApiPermission: {
        create: 'service.application_group.create',
        edit: 'service.ssl_certificate_group.update',
        delete: 'service.ssl_certificate_group.delete'
      }
    }
  },
  computed: {
    groupTreeFunc () {
      if (hasPermission(['service.ssl_certificate_group.view'])) {
        return {
          createFunc: createSSLCertificateGroup,
          deleteFunc: deleteSSLCertificateGroup,
          getFunc: getSSLCertificateGroup,
          getListFunc: getSSLCertificateGroupList,
          updateFunc: updateSSLCertificateGroup
        }
      } else return null
    }
  },
  mounted () {
    if (this.defaultSelected) this.tableDefaultSelectData = this.defaultSelected
  },
  methods: {
    getSelectData (data) {
      this.tableSelectData = data
      this.$emit('selectedData', data)
    },
    sync (id) {
      syncSSLCertificate({ id }).then(res => {
        this.$message.success(res.message)
      })
    },
    async confirm (id = '') {
      if (id) {
        await deleteSSLCertificate(id).then(res => {
          this.$message.success(res.message)
        })
        this.tableSelectData.splice(this.tableSelectData.findIndex(item => item.key === id), 1)
        this.tableDefaultSelectData = this.tableSelectData
        this.$emit('selectedData', this.tableSelectData)
      }
      this.updateTableFlag = !this.updateTableFlag
    }
  },
  watch: {
    refresh (v) {
      this.updateTableFlag = v
    }
  }
}
</script>
